import { useAuthStore } from '@/stores/useAuthStore';
import type { ChatIntent } from '@/types/chat';
import { withChatIntent } from '@/utils/chatIntent';
import { useActualRooms, type ActualChatRoom } from './actual';

const OPEN_STATUSES = ['OPEN', 'WAITING_HOST', 'WAITING_MEMBER'];

export const isOpenHostRoom = (room: ActualChatRoom) =>
  room.roomType === 'HOST' &&
  room.version < 2147483647 &&
  OPEN_STATUSES.includes(room.status);

/**
 * '호스트와 대화하기'의 목적지. 진행 중인 호스트 상담이 있으면 바로 그 대화로,
 * 회원의 기존 여정 상담을 이어가며, 새 게스트는 로그인 없이 간단 상담을 연다.
 * 별도의 MSW 참고 화면에서는 기존 소개 경로를 유지한다.
 */
export function useHostEntryPath(intent?: ChatIntent) {
  const authenticated = useAuthStore((s) => !!s.accessToken),
    rooms = useActualRooms(1);
  const open = authenticated
    ? rooms.data?.rows.find(isOpenHostRoom)
    : undefined;
  const demo =
    import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === 'true';
  return withChatIntent(
    open
      ? `/chat/${open.id}`
      : authenticated || demo
        ? '/diagnosis/1'
        : '/chat',
    intent,
  );
}
